import { Injectable } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { TourService as UITourService } from 'ngx-ui-tour-md-menu';
import { SettingsService } from '../settings/settings.service';
import { IMdStepOption } from 'ngx-ui-tour-md-menu/lib/step-option.interface';

@Injectable({
    providedIn: 'root',
})
export class TourService {
    active = false;

    get anchorUnregister$(): Subject<string> {
        return this.uiTourService.anchorUnregister$;
    }

    get events$() {
        return this.uiTourService.events$;
    }

    get currentStep(): IMdStepOption {
        return this.uiTourService.currentStep;
    }

    get anchorRegister$(): Subject<string> {
        return this.uiTourService.anchorRegister$;
    }

    constructor(
        private settingsService: SettingsService,
        private uiTourService: UITourService
    ) {}

    async init() {
        this.active = true;
        // TODO: translate
        this.uiTourService.initialize(
            [
                {
                    anchorId: 'menu.dashboard',
                    route: '/tabs/dashboard',
                    content:
                        'Po přihlášení do administrace se ocitnete na nástěnce - přehledovém panelu, který ukazuje aktuální stav systému. Vidíte, co se právě děje a přes rychlé odkazy se dostanete k nejčastějším akcím. Je to rozcestník, který vám zrychlí práci.',
                    title: 'Nástěnka',
                },
                {
                    anchorId: 'menu.toolbar',
                    route: '/tabs/dashboard',
                    content:
                        'Vpravo nahoře najdete uživatelské menu. Zde se můžete: \n &bull; Odhlásit z aplikace \n &bull; Přepnout jazyk \n &bull; Vyplnit informace o své společnosti \n &bull; Přejít do nákupního portálu Mediacloud \n &bull; Získat nápovědu nebo zobrazit obchodní podmínky',
                    title: 'Uživatelské menu',
                },
                // {
                //     anchorId: 'dashboard.players',
                //     route: '/tabs/dashboard',
                //     content: 'Karta provozoven je hlavním prostorem, odkud řídíte své provozovny, jejich nastavení a přehrávání.',
                //     title: 'Rychlý přehled zařízení',
                // },
                // {
                //     anchorId: 'dashboard.map',
                //     route: '/tabs/dashboard',
                //     content:
                //         'Pro větší přehled můžete své provozovny vidět i na mapě. Kliknutím na špendlík provozovny se zobrazí její detailní stránka.',
                //     title: 'Kde se co nachází',
                // },
                {
                    anchorId: 'menu.devices',
                    route: '/tabs/devices',
                    content:
                        'Sekce „Provozovny“ obsahuje seznam všech vašich míst, kde Dirigent hraje. Můžete si je: \n &bull; Označovat štítky (např. supermarket, čerpací stanice) \n &bull; Filtrovat dle názvu nebo štítku \n &bull; Kliknutím na konkrétní provozovnu upravit: \n &bull; Hudební nastavení (program, hlasitost, doba přehrávání) \n &bull; Informace (fotka, poznámky, kontakty) \n &bull; Certifikát k licencované hudbě \n &bull; Historii přehrávání',
                    title: 'Provozovny',
                },
                // {
                //     // isAsync: true,
                //     // asyncStepTimeout: 5000,
                //     anchorId: 'devices.detail.overview',
                //     route: '/tabs/devices?tour-preview',
                //     content: 'Po rozkliknutí některé z provozoven se zobrazí její detailní stránka, rozdělená na 3 karty. V kartě "Přehled" naleznete základní údaje o provozovně, její název, označení, adresu a štítky. Také můžete nahrát obrázek provozovny, například fotku hlavního vchodu, nebo instalovaného ozvučení. V pravé části obrazovky naleznete certifikát a údaj o jeho platnosti (využijete při kontrole), a také adresu hudebního přehrávače, vázaného na tuto licenci.',
                //     title: 'Karta přehled',
                // },
                // {
                //     // asyncStepTimeout: 5000,
                //     anchorId: 'devices.detail.programs',
                //     // route: '/tabs/devices?tour-preview',
                //     content: 'V prostřední kartě "Nastavení programu" si můžete vybrat, které hudební programy budou na provozovně k dispozici pro přehrání. Můžete tak zamezit, aby obsluha přehrávala něco, co na provozovnu nepatří. Pomocí zaškrtávacích polí označte všechny Dirigent programy a Vaše programy, které bude možné na provozovně přehrát. Toto nastavení můžete v administraci kdykoliv upravit.',
                //     title: 'Karta nastavení programů',
                // },
                // {
                //     // asyncStepTimeout: 5000,
                //     anchorId: 'devices.detail.history',
                //     // route: '/tabs/devices?tour-preview',
                //     content: 'Zaslechli jste na provozovně písničku, která není vhodná? Nebo se Vám naopak velmi líbí? Neznáte její název? V kartě "Historie přehrávání" (v detailu provozovny) se můžete k písničce vrátit a název si zjistit. Stačí si zapamatovat, v kolik hodin jste písničku zaslechli. Vrátit se v historii zpět můžete i v řádu dnů.',
                //     title: 'Karta historie přehrávání historie přehrávání',
                // },
                // {
                //     anchorId: 'devices.new',
                //     route: '/tabs/devices',
                //     content: 'Jak poroste Váš podnik, můžete přidávat v Dirigentu další provozovny a na každé hrát jiný program. Nebo všude stejný. Tlačítko "Nová provozovna" vás přesměruje do nákupního portálu, kam zadáte parametry provozovny (rozlohu, adresu, název...), a poté zaplatíte za její licenci. Hned poté můžete v administraci Dirigenta přistupovat k provozovně, upravovat některé její údaje, zobrazit si certifikát a samozřejmě tvořit hudební programy.',
                //     title: 'Nová provozovna',
                // },
                {
                    anchorId: 'menu.music',
                    // route: '/tabs/music',
                    content: 'Tady tvoříte a spravujete, co se bude hrát.',
                    title: 'Hudba',
                },
                {
                    anchorId: 'menu.music.public-programs',
                    route: '/tabs/music/programs?visibility=public',
                    content:
                        'Profesionálně připravené hudební programy pro různé typy provozů a denní doby. Můžete je rovnou použít a podle potřeby doplnit štítky pro snadnější přehled.',
                    title: 'Dirigent programy',
                },
                /*{
                    anchorId: 'music.public-programs',
                    route: '/tabs/music/programs?visibility=public',
                    content: 'Přidejte si program do oblíbených kliknutím na srdce pro rychlejší filtraci v provozovně.',
                    title: 'Oblíbené programy',
                },*/
                {
                    anchorId: 'menu.music.private-programs',
                    route: '/tabs/music/playlists?visibility=private',
                    content:
                        'Hudební program je celek složený z několika playlistů. Program si pojmenujete - třeba "Ranní špička", "Letní energie" nebo "Večerní pohoda". Do programu přidáváte různé playlisty a určujete, jak často se mají střídat. Můžete tak vyvážit náladu podle denní doby nebo typu provozu. Dirigent si podle těchto nastavení sám vybírá skladby z příslušných playlistů a míchá je do výsledného vysílání.',
                    title: 'Vaše programy',
                },
                {
                    anchorId: 'menu.music.public-playlists',
                    route: '/tabs/music/playlists?visibility=public',
                    content:
                        'Pokud nechcete vytvářet playlisty od nuly, můžete využít předpřipravené playlisty od Dirigenta. Vyberete si z nabídky a rovnou je zařadíte do svých hudebních programů.',
                    title: 'Dirigent playlisty',
                },
                /*{
                    anchorId: 'music.public-playlists',
                    route: '/tabs/music/playlists?visibility=public',
                    content: 'Přidejte si playlisty do oblíbených kliknutím na srdce pro rychlejší filtraci při mixování programů.',
                    title: 'Oblíbené playlisty',
                },*/
                /*{
                    anchorId: 'music.private-programs.new',
                    route: '/tabs/music/programs?visibility=private',
                    content: 'Vytvořte si nový program z vašich a předpřipravených playlistů.',
                    title: 'Nový program',
                },*/
                {
                    anchorId: 'menu.music.private-playlists',
                    route: '/tabs/music/playlists?visibility=private',
                    content:
                        'Vlastní playlist si sestavíte ve čtyřech krocích: \n\nNejdříve pojmenujete playlist a přidáte mu štítky. Poté vyberete žánry, které chcete zahrnout. Pomocí čtvercového grafu nastavíte náladu - například jestli má být hudba spíš veselá, rychlá, pomalá nebo klidná. A nakonec si můžete projít konkrétní skladby, přehrát si jejich náhled a případně je z playlistu odebrat. Výsledný playlist se pak dá využít v libovolném počtu programů.',
                    title: 'Vaše playlisty',
                },
                {
                    anchorId: 'menu.jingles',
                    route: '/tabs/jingles',
                    content:
                        'Jingly jsou krátké zvukové předěly nebo hlášky, které se přehrávají mezi skladbami, např. znělka vaší značky. Jejich plánování probíhá přes tzv. kampaně. V jedné kampani může být více jinglů, které se automaticky střídají. Můžete si vytvořit samostatné kampaně pro různou denní dobu - např. jiné jingly pro ráno, jiné pro večer. Jingly se spouští na zvolených provozovnách podle přesně nastaveného harmonogramu. Funkce je dostupná pouze v tarifu Opus nebo Event.',
                    title: 'Jingly',
                },
                {
                    anchorId: 'menu.spots',
                    route: '/tabs/spots',
                    content:
                        'Systém umožňuje i přehrávání reklamních spotů - například vlastních sdělení nebo spotů dodavatelů. Reklamy se plánují pomocí kampaní podobně jako jingly. Na rozdíl od jinglů se však reklamy přehrávají v přesně definovaných blocích. Každá kampaň obsahuje jednu reklamu a vy si zvolíte, kdy, kde a jak hlasitě se má přehrát. Hlasitost reklam lze nastavit samostatně v detailu provozovny. Funkce je dostupná pouze v tarifu Opus nebo Event.',
                    title: 'Reklamy',
                },
                /* {
                     anchorId: 'music.private-playlists.new',
                     route: '/tabs/music/playlists?visibility=private',
                     content: 'Vytvořte si playlist, které si vytvoříte  podle vašich preferencí.',
                     title: 'Nový playlist',
                 },*/
            ],
            {
                enableBackdrop: true,
                prevBtnTitle: 'Zpět',
                nextBtnTitle: 'Další',
                endBtnTitle: 'Konec',
            }
        );

        // start only when first visit
        const settings = await firstValueFrom(this.settingsService.settings$);
        if (!settings.tourCompleted) {
            this.uiTourService.start();
            this.uiTourService.end$.subscribe(() => {
                this.settingsService.setTourCompleted();
                console.log('end');
            });
        }
    }
}
